import { Box, Container, createTheme, CssBaseline, Grid, ThemeProvider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getAllIn } from "../../services/crudCustom";

export const VisualizarResumenes = (props) => {
    const { event } = props;
    const { tabla } = event;

    // state para almacenar la data 
    const [resumenes, setResumenes] = useState([
        {
            registroReferencia: "222",
        }
    ]);



    useEffect(() => {
      
        const getData = async() => {
            const getRecords = await getAllIn({ table: tabla });
            
            if (getRecords.exito === 0) {
                console.log('No se pudo recuperar la info');
                return false;
            }
            const data = getRecords.data;
            
            const trabajosArray = [];
            data.forEach( ({ registroReferencia, partNombres, partApellidoPaterno, trabajos }) => {
                // console.log(registroReferencia, partNombres, partApellidoPaterno);
                
                const trabajosParsed = JSON.parse(trabajos);
                // console.log(trabajosParsed); 

                trabajosParsed.forEach( ({ trabTitulo, trabResumenURL, trabResumenURLLabel, trabModalidad }) => {
                    // console.log(trabajo);
                    trabajosArray.push({
                        registroReferencia, 
                        partNombres, 
                        partApellidoPaterno, 
                        trabTitulo, 
                        trabResumenURL, 
                        trabResumenURLLabel,
                        trabModalidad
                    })
                    
                })
            })
            console.log(trabajosArray);
            setResumenes(trabajosArray);

            // Contar trabajos
            const ponenciasOrales = trabajosArray.filter( trab => trab.trabModalidad === "Ponencia Oral")
            console.log(`Ponenecias orales: ${ponenciasOrales.length}`);
            const ponenciasPoster = trabajosArray.filter( trab => trab.trabModalidad === "Póster")
            console.log(`Ponenecias poster: ${ponenciasPoster.length}`);
        }

        getData();
    }, [ tabla ])

    

    return (
        <>
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sl">
            <CssBaseline />
                <Box
                    sx={{
                        mt: 6,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                <Grid item xs={12}>
                    <Typography align="center" variant="h4">
                        { event.tituloEvento }
                    </Typography>
                    <Typography align="center" variant="subtitle1">
                        Concentrado de resumenes
                    </Typography>
                </Grid>
                    {/* Contenedor general */}
                    <Grid container
                        maxWidth={window.innerWidth}
                        spacing={2}
                        sx={{ pt: 2, pb: 3 }}
                    >
                        {                            
                            // // List all entries
                            resumenes.map((res, key) => 
                                <Grid item xs={12} key={ key }>
                                    <Typography>
                                        <strong>{ res.registroReferencia }</strong> { res.partNombres } { res.partApellidoPaterno }
                                    </Typography>
                                    <Typography>
                                        <a href={ res.trabResumenURL } target="_blank" rel="noreferrer" >{ res.trabTitulo }</a>
                                    </Typography>
                                </Grid>
                            )
                        }

                        <Grid item xs={12}>
                            <Typography>
                                Total de trabajos: <strong>{ resumenes.length }</strong>
                            </Typography>
                        </Grid>
                    </Grid>

                </Box>
            </Container>
        </ThemeProvider>
        </>
    );
};
